import { render, staticRenderFns } from "./ModalUserDepartamentComponent.vue?vue&type=template&id=1d66939c"
import script from "./ModalUserDepartamentComponent.vue?vue&type=script&lang=js"
export * from "./ModalUserDepartamentComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalUserDepartamentComponent.vue?vue&type=style&index=0&id=1d66939c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports